import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "tw-font-semibold" }, "Visitor tracking consent is on", -1)
const _hoisted_2 = {
  key: 0,
  class: "tw-mt-1"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "tw-font-mono" }, "data-consent-type=\"analytics\"", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "tw-font-mono" }, "\"marketing\"", -1)
const _hoisted_5 = { class: "tw-mt-1" }
const _hoisted_6 = { class: "tw-mt-1 tw-overflow-x-auto tw-rounded tw-bg-white/60 tw-p-2 tw-font-mono tw-text-xs" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "tw-mt-1" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-mono" }, "analytics"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-font-mono" }, "marketing"),
  /*#__PURE__*/_createTextVNode(", whichever the script belongs to. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioAlertBanner = _resolveComponent("StudioAlertBanner")!

  return (_openBlock(), _createBlock(_component_StudioAlertBanner, {
    type: "info",
    "data-testId": "tracking-consent-notice"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      (_ctx.showTagRule)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createTextVNode(" Tracking tags in Head and Body need a category. Add "),
            _hoisted_3,
            _createTextVNode(" or "),
            _hoisted_4,
            _createTextVNode(" to each one — unclassified tags are flagged in the editor. ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.scriptFieldsExplanation), 1),
      _createElementVNode("pre", _hoisted_6, _toDisplayString(_ctx.guard), 1),
      _hoisted_7
    ]),
    _: 1
  }))
}